import { LANGUAGE_CODE } from '@healthhub/react-ui';
import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  INBOX_NOTIFICATION_DETAILS_PATH,
  INBOX_NOTIFICATIONS_PATH,
  INBOX_PUBLIC_NOTIFICATIONS_PATH,
} from '@shared/constants/paths';

const PublicInboxNotificationsPage = lazy(
  () => import('./pages/PublicInboxNotificationsPage/PublicInboxNotificationsPage')
);
const InboxNotificationsPage = lazy(() => import('./pages/InboxNotificationsPage/InboxNotificationsPage'));
const InboxNotificationDetailsPage = lazy(
  () => import('./pages/InboxNotificationDetailsPage/InboxNotificationDetailsPage')
);

export const INBOX_NOTIFICATION_ROUTES = [
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PublicInboxNotificationsPage />,
    displayTitle: () => 'Inbox',
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: INBOX_PUBLIC_NOTIFICATIONS_PATH,
    serviceCatalogCode: '',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <InboxNotificationDetailsPage />,
    displayTitle: () => 'Inbox',
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: INBOX_NOTIFICATION_DETAILS_PATH,
    serviceCatalogCode: '',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <InboxNotificationsPage />,
    displayTitle: () => 'Inbox',
    pageType: PageType.PRIVATE,
    path: INBOX_NOTIFICATIONS_PATH,
    serviceCatalogCode: '',
  },
];
